import React from 'react';

import loadingLogo from 'assets/images/loading.gif';
import { ReturnComponentType } from 'common';
import './Loader.scss';
import { useAppSelector } from 'hooks';
import { selectLoading } from 'state';

export const Loader = (): ReturnComponentType => {
  const isLoading = useAppSelector(selectLoading);

  return isLoading ? (
    <img src={loadingLogo} alt="loading-logo" className="Loader" />
  ) : null;
};
